/// THIS IS AUTOGENERATED FILE! Generation time: 2025-11-26T08:18:29.4003960+00:00

export interface IBaseAnalyticsEvent {
    UserId: number; // ulong becomes number
    CreatedAt: number; // DateTime's ToUnixTimeMilliseconds
    ServerCreatedAt: number; // DateTime's ToUnixTimeMilliseconds
    Build: number; // uint becomes number
    Platform: number; // uint becomes number
    GeoCountryCode?: string | null;
    GetCountryNum?: number | null; // uint becomes number
    GeoLon?: number | null;
    GeoLat?: number | null;
}

export interface IAnalyticsEvent extends IBaseAnalyticsEvent {
    EventId: number; // uint becomes number
    I1?: number | null;
    I2?: number | null;
    I3?: number | null;
    I4?: number | null;
    I5?: number | null;
    I6?: number | null;
    I7?: number | null;
    I8?: number | null;
    I9?: number | null;
    I10?: number | null;
    F1?: number | null;
    F2?: number | null;
    F3?: number | null;
    F4?: number | null;
    F5?: number | null;
    F6?: number | null;
    F7?: number | null;
    F8?: number | null;
    F9?: number | null;
    F10?: number | null;
    S1?: string | null;
    S2?: string | null;
    S3?: string | null;
    S4?: string | null;
    S5?: string | null;
    S6?: string | null;
    S7?: string | null;
    S8?: string | null;
    S9?: string | null;
    S10?: string | null;
    S11?: string | null;
    S12?: string | null;
    S13?: string | null;
    S14?: string | null;
    S15?: string | null;
    J1?: string | null; // JSON stored as string
    J2?: string | null;
    J3?: string | null;
    J4?: string | null;
}

export interface IAnalyticsEventsSender {
    BuildEvent: (createdAt?: number) => IBaseAnalyticsEvent;
    SendEvent: (analyticsEvent: IAnalyticsEvent) => Promise<void>;
}

// NAMED ENUMS

export enum Merchant {Yookassa = 0,Xsolla = 1,Odnoklassniki = 2,Vkontaktecom = 3,Vkontakteplay = 4,Yandexgames = 5,Absolutegames = 6,Kongregate = 7,Stripe = 8,Facebookgames = 9,Moneymailru = 10,Bank131 = 11,Wizq = 12,Rustore = 13,Telegram = 14,Googleplay = 15,Appstore = 16,Steam = 17,Onestore = 18,Facebookinstantgames = 19,Epicgamesstore = 20,Promocode = 21,Yandexgamesbonusmerchant = 22,Aghanim = 23,Crazygames = 24,Crossplay = 25,Wechat = 26,Dummy = 100}

export enum OrderState {Created = 0,Waitingforpayment = 1,Payedwaitingforsending = 2,Cancelledpaid = 898,Cancelled = 899,Completed = 999}

export enum SocialIdentifierType {Unspecified = 0,Email = 1,Telegram = 2,Firebase = 3,Vkontakteplay = 4,Odnoklassniki = 5,Vkontaktecom = 6,Yandexgames = 7,Fxid = 8,Yandexgamesguest = 9,Facebook = 10,Google = 11,Apple = 12,Absolutegamesguest = 13,Absolutegames = 14,Kongregateguest = 15,Kongregate = 16,Vkontaktecomoauth = 17,Xsolla = 18,Facebookgames = 19,Crazygamesguest = 20,Crazygames = 21,Mygamesid = 22,Wizq = 23,Steam = 25,Egs = 26,Twitch = 27}
















































































// EVENT-SPECIFIC ENUMS
export enum AnalyticsEventDownloadStatusState {Added = 0,Resuming = 1,Checking = 2,Loading = 3,Downloading = 4,Finished = 5,Seeding = 6,Idle = 7}
export class AnalyticsEvents {
    private readonly _sender: IAnalyticsEventsSender;

    constructor(sender: IAnalyticsEventsSender) {
        this._sender = sender;
    }
    
    /**
     * Event Name: download_request_track
     * Event ID: 781965163
     * Description: Download request tracking
     */
    public BuildDownloadRequestTrack(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionIdStr: string,url: string,queryString: string,query: string,sessionId: number,cookies: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965163,S1: game,S2: sessionIdStr,S3: url,S4: queryString,S5: query,I1: sessionId,J2: cookies};
    }

    /**
     * Event Name: download_request_track
     * Event ID: 781965163
     * Description: Download request tracking
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param url Url
     * @param queryString QueryString
     * @param query Query
     * @param sessionId SessionId
     * @param cookies Cookies
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendDownloadRequestTrack(game: string,
            sessionIdStr: string,
            url: string,
            queryString: string,
            query: string,
            sessionId: number,
            cookies: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildDownloadRequestTrack(
            this._sender.BuildEvent(createdAt),game,sessionIdStr,url,queryString,query,sessionId,cookies);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: download_track
     * Event ID: 781965166
     * Description: Download file with session tracking
     */
    public BuildDownloadTrack(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionIdStr: string,sessionId: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965166,S1: game,S2: sessionIdStr,I1: sessionId};
    }

    /**
     * Event Name: download_track
     * Event ID: 781965166
     * Description: Download file with session tracking
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param sessionId SessionId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendDownloadTrack(game: string,
            sessionIdStr: string,
            sessionId: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildDownloadTrack(
            this._sender.BuildEvent(createdAt),game,sessionIdStr,sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: authenticate_with_ext_id_signup
     * Event ID: 781965164
     * Description: AuthenticateWithExternalId signup
     */
    public BuildAuthenticateWithExtIdSignup(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionIdStr: string,email: string,sessionId: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965164,S1: game,S2: sessionIdStr,S3: email,I1: sessionId};
    }

    /**
     * Event Name: authenticate_with_ext_id_signup
     * Event ID: 781965164
     * Description: AuthenticateWithExternalId signup
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param email Email
     * @param sessionId SessionId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendAuthenticateWithExtIdSignup(game: string,
            sessionIdStr: string,
            email: string,
            sessionId: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildAuthenticateWithExtIdSignup(
            this._sender.BuildEvent(createdAt),game,sessionIdStr,email,sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: authenticate_with_ext_id_login
     * Event ID: 781965165
     * Description: AuthenticateWithExternalId login
     */
    public BuildAuthenticateWithExtIdLogin(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionIdStr: string,email: string,sessionId: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965165,S1: game,S2: sessionIdStr,S3: email,I1: sessionId};
    }

    /**
     * Event Name: authenticate_with_ext_id_login
     * Event ID: 781965165
     * Description: AuthenticateWithExternalId login
     * @param game Game
     * @param sessionIdStr SessionIdStr
     * @param email Email
     * @param sessionId SessionId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendAuthenticateWithExtIdLogin(game: string,
            sessionIdStr: string,
            email: string,
            sessionId: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildAuthenticateWithExtIdLogin(
            this._sender.BuildEvent(createdAt),game,sessionIdStr,email,sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: download_status
     * Event ID: 781965176
     * Description: Download status
     */
    public BuildDownloadStatus(
        analyticsEvent: IBaseAnalyticsEvent,branch: string,game: string,sessionId: number,state: AnalyticsEventDownloadStatusState,uploadSpeedBytes: number,downloadSeedBytes: number,buildId: number,progress: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965176,S1: branch,S2: game,I1: sessionId,I2: state,I3: uploadSpeedBytes,I4: downloadSeedBytes,I5: buildId,F1: progress};
    }

    /**
     * Event Name: download_status
     * Event ID: 781965176
     * Description: Download status
     * @param branch Branch
     * @param game Game
     * @param sessionId SessionId
     * @param state State
     * @param uploadSpeedBytes UploadSpeedBytes
     * @param downloadSeedBytes DownloadSeedBytes
     * @param buildId BuildId
     * @param progress Progress
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendDownloadStatus(branch: string,
            game: string,
            sessionId: number,
            state: AnalyticsEventDownloadStatusState,
            uploadSpeedBytes: number,
            downloadSeedBytes: number,
            buildId: number,
            progress: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildDownloadStatus(
            this._sender.BuildEvent(createdAt),branch,game,sessionId,state,uploadSpeedBytes,downloadSeedBytes,buildId,progress);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: change_state
     * Event ID: 781965177
     * Description: Change state
     */
    public BuildChangeState(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionId: number,fromState: number,toState: number,timeBetweenSeconds: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965177,S1: game,I1: sessionId,I2: fromState,I3: toState,F1: timeBetweenSeconds};
    }

    /**
     * Event Name: change_state
     * Event ID: 781965177
     * Description: Change state
     * @param game Game
     * @param sessionId SessionId
     * @param fromState FromState
     * @param toState ToState
     * @param timeBetweenSeconds TimeBetweenSeconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendChangeState(game: string,
            sessionId: number,
            fromState: number,
            toState: number,
            timeBetweenSeconds: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildChangeState(
            this._sender.BuildEvent(createdAt),game,sessionId,fromState,toState,timeBetweenSeconds);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: game_connected
     * Event ID: 781965178
     * Description: Game connected
     */
    public BuildGameConnected(
        analyticsEvent: IBaseAnalyticsEvent,game: string,gameId: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965178,S1: game,S2: gameId};
    }

    /**
     * Event Name: game_connected
     * Event ID: 781965178
     * Description: Game connected
     * @param game Game
     * @param gameId GameId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendGameConnected(game: string,
            gameId: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildGameConnected(
            this._sender.BuildEvent(createdAt),game,gameId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: launcher_started
     * Event ID: 781965179
     * Description: Launcher started
     */
    public BuildLauncherStarted(
        analyticsEvent: IBaseAnalyticsEvent,appCode: string,clientGuid: string,fxapiApiType: string,fxapiCefVersion: string,fxapiAppVersion: string,fxapiLoaderName: string,fxapiHwProfileGuid: string,fxapiIsSteamdeck: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965179,S1: appCode,S2: clientGuid,S3: fxapiApiType,S4: fxapiCefVersion,S5: fxapiAppVersion,S6: fxapiLoaderName,S7: fxapiHwProfileGuid,I1: fxapiIsSteamdeck};
    }

    /**
     * Event Name: launcher_started
     * Event ID: 781965179
     * Description: Launcher started
     * @param appCode AppCode
     * @param clientGuid ClientGuid
     * @param fxapiApiType FxapiApiType
     * @param fxapiCefVersion FxapiCefVersion
     * @param fxapiAppVersion FxapiAppVersion
     * @param fxapiLoaderName FxapiLoaderName
     * @param fxapiHwProfileGuid FxapiHwProfileGuid
     * @param fxapiIsSteamdeck FxapiIsSteamdeck
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendLauncherStarted(appCode: string,
            clientGuid: string,
            fxapiApiType: string,
            fxapiCefVersion: string,
            fxapiAppVersion: string,
            fxapiLoaderName: string,
            fxapiHwProfileGuid: string,
            fxapiIsSteamdeck: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildLauncherStarted(
            this._sender.BuildEvent(createdAt),appCode,clientGuid,fxapiApiType,fxapiCefVersion,fxapiAppVersion,fxapiLoaderName,fxapiHwProfileGuid,fxapiIsSteamdeck);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: order_state_changed
     * Event ID: 781965182
     * Description: Order state changed
     */
    public BuildOrderStateChanged(
        analyticsEvent: IBaseAnalyticsEvent,game: string,skuCode: string,additionalProductsSkus: string,currency: string,currencySkuPrice: string,merchant: string,merchantCurrency: string,paymentMethod: string,orderId: string,orderPublicId: string,orderState: OrderState,previousOrderState: OrderState,merchantId: Merchant,usdPriceTier: number,merchantValue: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965182,S1: game,S2: skuCode,S3: additionalProductsSkus,S4: currency,S5: currencySkuPrice,S6: merchant,S7: merchantCurrency,S8: paymentMethod,S9: orderId,S10: orderPublicId,I1: orderState,I2: previousOrderState,I3: merchantId,F1: usdPriceTier,F2: merchantValue};
    }

    /**
     * Event Name: order_state_changed
     * Event ID: 781965182
     * Description: Order state changed
     * @param game Game
     * @param skuCode Product sku
     * @param additionalProductsSkus Additional products skus
     * @param currency Currency
     * @param currencySkuPrice Price in currency
     * @param merchant Merchant used for payment
     * @param merchantCurrency Currency that merchant used for payment
     * @param paymentMethod Test payment method or not
     * @param orderId Id of the order in database
     * @param orderPublicId Public id of the order in database
     * @param orderState OrderState
     * @param previousOrderState PreviousOrderState
     * @param merchantId Merchant used for payment
     * @param usdPriceTier Price in usd for price tier that was chosen
     * @param merchantValue Amount of merchant_currency that merchant added for the order
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendOrderStateChanged(game: string, // Game 
            skuCode: string, // Product sku 
            additionalProductsSkus: string, // Additional products skus 
            currency: string, // Currency 
            currencySkuPrice: string, // Price in currency 
            merchant: string, // Merchant used for payment 
            merchantCurrency: string, // Currency that merchant used for payment 
            paymentMethod: string, // Test payment method or not 
            orderId: string, // Id of the order in database 
            orderPublicId: string, // Public id of the order in database 
            orderState: OrderState,
            previousOrderState: OrderState,
            merchantId: Merchant, // Merchant used for payment 
            usdPriceTier: number, // Price in usd for price tier that was chosen 
            merchantValue: number, // Amount of merchant_currency that merchant added for the order 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildOrderStateChanged(
            this._sender.BuildEvent(createdAt),game,skuCode,additionalProductsSkus,currency,currencySkuPrice,merchant,merchantCurrency,paymentMethod,orderId,orderPublicId,orderState,previousOrderState,merchantId,usdPriceTier,merchantValue);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: social_identifier_added
     * Event ID: 781965183
     * Description: Social identifier added
     */
    public BuildSocialIdentifierAdded(
        analyticsEvent: IBaseAnalyticsEvent,identifier: string,identifierType: SocialIdentifierType): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965183,S1: identifier,I1: identifierType};
    }

    /**
     * Event Name: social_identifier_added
     * Event ID: 781965183
     * Description: Social identifier added
     * @param identifier Identifier
     * @param identifierType IdentifierType
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSocialIdentifierAdded(identifier: string,
            identifierType: SocialIdentifierType,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSocialIdentifierAdded(
            this._sender.BuildEvent(createdAt),identifier,identifierType);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: user_review
     * Event ID: 781965184
     * Description: User submitted a review
     */
    public BuildUserReview(
        analyticsEvent: IBaseAnalyticsEvent,game: string,reviewText: string,score: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965184,S1: game,S2: reviewText,I1: score};
    }

    /**
     * Event Name: user_review
     * Event ID: 781965184
     * Description: User submitted a review
     * @param game Game
     * @param reviewText ReviewText
     * @param score Score
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendUserReview(game: string,
            reviewText: string,
            score: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildUserReview(
            this._sender.BuildEvent(createdAt),game,reviewText,score);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_personal_information_form_shown
     * Event ID: 781965186
     * Description: Web UI personal information form shown
     */
    public BuildWebUiPersonalInformationFormShown(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965186,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_personal_information_form_shown
     * Event ID: 781965186
     * Description: Web UI personal information form shown
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiPersonalInformationFormShown(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiPersonalInformationFormShown(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_personal_information_form_autofilled
     * Event ID: 781965187
     * Description: Web UI personal information form autofilled
     */
    public BuildWebUiPersonalInformationFormAutofilled(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965187,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_personal_information_form_autofilled
     * Event ID: 781965187
     * Description: Web UI personal information form autofilled
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiPersonalInformationFormAutofilled(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiPersonalInformationFormAutofilled(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_personal_information_form_submitted
     * Event ID: 781965188
     * Description: Web UI personal information form submitted
     */
    public BuildWebUiPersonalInformationFormSubmitted(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965188,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_personal_information_form_submitted
     * Event ID: 781965188
     * Description: Web UI personal information form submitted
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiPersonalInformationFormSubmitted(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiPersonalInformationFormSubmitted(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_bank131_form_shown
     * Event ID: 781965189
     * Description: Web UI bank131 form shown
     */
    public BuildWebUiBank131FormShown(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965189,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_bank131_form_shown
     * Event ID: 781965189
     * Description: Web UI bank131 form shown
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiBank131FormShown(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiBank131FormShown(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_bank131_form_card_clicked
     * Event ID: 781965190
     * Description: Web UI bank131 form card clicked
     */
    public BuildWebUiBank131FormCardClicked(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965190,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_bank131_form_card_clicked
     * Event ID: 781965190
     * Description: Web UI bank131 form card clicked
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiBank131FormCardClicked(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiBank131FormCardClicked(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_bank131_form_fps_clicked
     * Event ID: 781965191
     * Description: Web UI bank131 form fps clicked
     */
    public BuildWebUiBank131FormFpsClicked(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965191,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_bank131_form_fps_clicked
     * Event ID: 781965191
     * Description: Web UI bank131 form fps clicked
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiBank131FormFpsClicked(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiBank131FormFpsClicked(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_bank131_form_card_submitted
     * Event ID: 781965192
     * Description: Web UI bank131 form card submitted
     */
    public BuildWebUiBank131FormCardSubmitted(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965192,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_bank131_form_card_submitted
     * Event ID: 781965192
     * Description: Web UI bank131 form card submitted
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiBank131FormCardSubmitted(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiBank131FormCardSubmitted(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: web_ui_bank131_form_fps_submitted
     * Event ID: 781965193
     * Description: Web UI bank131 form fps submitted
     */
    public BuildWebUiBank131FormFpsSubmitted(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965193,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: web_ui_bank131_form_fps_submitted
     * Event ID: 781965193
     * Description: Web UI bank131 form fps submitted
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendWebUiBank131FormFpsSubmitted(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildWebUiBank131FormFpsSubmitted(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: payment_bank131_fps_data_received
     * Event ID: 781965194
     * Description: Payment bank131 fps data received
     */
    public BuildPaymentBank131FpsDataReceived(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965194,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: payment_bank131_fps_data_received
     * Event ID: 781965194
     * Description: Payment bank131 fps data received
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendPaymentBank131FpsDataReceived(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildPaymentBank131FpsDataReceived(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: payment_bank131_fps_data_receiving_error
     * Event ID: 781965195
     * Description: Payment bank131 fps data receiving error
     */
    public BuildPaymentBank131FpsDataReceivingError(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965195,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: payment_bank131_fps_data_receiving_error
     * Event ID: 781965195
     * Description: Payment bank131 fps data receiving error
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendPaymentBank131FpsDataReceivingError(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildPaymentBank131FpsDataReceivingError(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: payment_bank131_card_success
     * Event ID: 781965196
     * Description: Payment bank131 card success
     */
    public BuildPaymentBank131CardSuccess(
        analyticsEvent: IBaseAnalyticsEvent,publicOrderId: string,source: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965196,S1: publicOrderId,S2: source};
    }

    /**
     * Event Name: payment_bank131_card_success
     * Event ID: 781965196
     * Description: Payment bank131 card success
     * @param publicOrderId PublicOrderId
     * @param source Source
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendPaymentBank131CardSuccess(publicOrderId: string,
            source: string,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildPaymentBank131CardSuccess(
            this._sender.BuildEvent(createdAt),publicOrderId,source);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: payment_bank131_card_cancelled
     * Event ID: 781965197
     * Description: Payment bank131 card canceled
     */
    public BuildPaymentBank131CardCancelled(
        analyticsEvent: IBaseAnalyticsEvent,orderId: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965197,I1: orderId};
    }

    /**
     * Event Name: payment_bank131_card_cancelled
     * Event ID: 781965197
     * Description: Payment bank131 card canceled
     * @param orderId OrderId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendPaymentBank131CardCancelled(orderId: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildPaymentBank131CardCancelled(
            this._sender.BuildEvent(createdAt),orderId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: payment_bank131_fps_success
     * Event ID: 781965198
     * Description: Payment bank131 fps success
     */
    public BuildPaymentBank131FpsSuccess(
        analyticsEvent: IBaseAnalyticsEvent,orderId: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965198,I1: orderId};
    }

    /**
     * Event Name: payment_bank131_fps_success
     * Event ID: 781965198
     * Description: Payment bank131 fps success
     * @param orderId OrderId
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendPaymentBank131FpsSuccess(orderId: number,
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildPaymentBank131FpsSuccess(
            this._sender.BuildEvent(createdAt),orderId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: game_loading_started
     * Event ID: 781965202
     * Description: Game loading started
     */
    public BuildGameLoadingStarted(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionId: string,buildId: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965202,S1: game,S2: sessionId,I1: buildId};
    }

    /**
     * Event Name: game_loading_started
     * Event ID: 781965202
     * Description: Game loading started
     * @param game Game name
     * @param sessionId Session id
     * @param buildId Build version
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendGameLoadingStarted(game: string, // Game name 
            sessionId: string, // Session id 
            buildId: number, // Build version 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildGameLoadingStarted(
            this._sender.BuildEvent(createdAt),game,sessionId,buildId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: game_launched
     * Event ID: 781965203
     * Description: Game launched successfully
     */
    public BuildGameLaunched(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionId: string,buildId: number,loadingTimeSeconds: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965203,S1: game,S2: sessionId,I1: buildId,F1: loadingTimeSeconds};
    }

    /**
     * Event Name: game_launched
     * Event ID: 781965203
     * Description: Game launched successfully
     * @param game Game name
     * @param sessionId Session id
     * @param buildId Build version
     * @param loadingTimeSeconds Loading time in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendGameLaunched(game: string, // Game name 
            sessionId: string, // Session id 
            buildId: number, // Build version 
            loadingTimeSeconds: number, // Loading time in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildGameLaunched(
            this._sender.BuildEvent(createdAt),game,sessionId,buildId,loadingTimeSeconds);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: client_exception
     * Event ID: 781965204
     * Description: Client exception occurred
     */
    public BuildClientException(
        analyticsEvent: IBaseAnalyticsEvent,game: string,exceptionType: string,exceptionMessage: string,stackTrace: string,sessionId: string): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965204,S1: game,S2: exceptionType,S3: exceptionMessage,S4: stackTrace,S5: sessionId};
    }

    /**
     * Event Name: client_exception
     * Event ID: 781965204
     * Description: Client exception occurred
     * @param game Game name
     * @param exceptionType Exception type
     * @param exceptionMessage Exception message
     * @param stackTrace Stack trace
     * @param sessionId Session id
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendClientException(game: string, // Game name 
            exceptionType: string, // Exception type 
            exceptionMessage: string, // Exception message 
            stackTrace: string, // Stack trace 
            sessionId: string, // Session id 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildClientException(
            this._sender.BuildEvent(createdAt),game,exceptionType,exceptionMessage,stackTrace,sessionId);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: client_performance
     * Event ID: 781965205
     * Description: Client performance metrics
     */
    public BuildClientPerformance(
        analyticsEvent: IBaseAnalyticsEvent,game: string,sessionId: string,memoryMb: number,fps: number,clicksCount: number,mouseDistancePixels: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965205,S1: game,S2: sessionId,I1: memoryMb,I2: fps,I3: clicksCount,F1: mouseDistancePixels};
    }

    /**
     * Event Name: client_performance
     * Event ID: 781965205
     * Description: Client performance metrics
     * @param game Game name
     * @param sessionId Session id
     * @param memoryMb Memory usage in MB
     * @param fps Frames per second
     * @param clicksCount Number of clicks
     * @param mouseDistancePixels Mouse distance in pixels
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendClientPerformance(game: string, // Game name 
            sessionId: string, // Session id 
            memoryMb: number, // Memory usage in MB 
            fps: number, // Frames per second 
            clicksCount: number, // Number of clicks 
            mouseDistancePixels: number, // Mouse distance in pixels 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildClientPerformance(
            this._sender.BuildEvent(createdAt),game,sessionId,memoryMb,fps,clicksCount,mouseDistancePixels);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_user_authentication_forced
     * Event ID: 781965206
     * Description: SDK user authentication forced
     */
    public BuildSdkUserAuthenticationForced(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,providerId: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965206,S1: sessionId,S2: game,S3: adapter,S4: providerId,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_user_authentication_forced
     * Event ID: 781965206
     * Description: SDK user authentication forced
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param providerId Auth provider id
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkUserAuthenticationForced(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            providerId: string, // Auth provider id 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkUserAuthenticationForced(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,providerId,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_user_logged_in_fxid
     * Event ID: 781965207
     * Description: SDK user logged in FxId
     */
    public BuildSdkUserLoggedInFxid(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,domain: string,screenResolution: string,os: string,browser: string,browserVersion: string,sessionNumber: number,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965207,S1: sessionId,S2: game,S3: adapter,S4: domain,S5: screenResolution,S6: os,S7: browser,S8: browserVersion,I1: sessionNumber,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_user_logged_in_fxid
     * Event ID: 781965207
     * Description: SDK user logged in FxId
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param domain Domain
     * @param screenResolution Screen resolution (e.g. 1920x1080)
     * @param os Operating system
     * @param browser Browser name
     * @param browserVersion Browser version
     * @param sessionNumber Session number (incremental counter)
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkUserLoggedInFxid(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            domain: string, // Domain 
            screenResolution: string, // Screen resolution (e.g. 1920x1080) 
            os: string, // Operating system 
            browser: string, // Browser name 
            browserVersion: string, // Browser version 
            sessionNumber: number, // Session number (incremental counter) 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkUserLoggedInFxid(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,domain,screenResolution,os,browser,browserVersion,sessionNumber,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_iframe_modal_opened
     * Event ID: 781965208
     * Description: SDK iframe modal opened
     */
    public BuildSdkIframeModalOpened(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,url: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965208,S1: sessionId,S2: game,S3: adapter,S4: url,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_iframe_modal_opened
     * Event ID: 781965208
     * Description: SDK iframe modal opened
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param url Modal URL
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkIframeModalOpened(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            url: string, // Modal URL 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkIframeModalOpened(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,url,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_language_changed
     * Event ID: 781965209
     * Description: SDK language changed
     */
    public BuildSdkLanguageChanged(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,oldLang: string,newLang: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965209,S1: sessionId,S2: game,S3: adapter,S4: oldLang,S5: newLang,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_language_changed
     * Event ID: 781965209
     * Description: SDK language changed
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param oldLang Old language
     * @param newLang New language
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkLanguageChanged(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            oldLang: string, // Old language 
            newLang: string, // New language 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkLanguageChanged(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,oldLang,newLang,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_report_modal_opened
     * Event ID: 781965210
     * Description: SDK report modal opened
     */
    public BuildSdkReportModalOpened(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965210,S1: sessionId,S2: game,S3: adapter,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_report_modal_opened
     * Event ID: 781965210
     * Description: SDK report modal opened
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkReportModalOpened(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkReportModalOpened(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_product_purchase_requested
     * Event ID: 781965211
     * Description: SDK product purchase requested
     */
    public BuildSdkProductPurchaseRequested(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,productSku: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965211,S1: sessionId,S2: game,S3: adapter,S4: productSku,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_product_purchase_requested
     * Event ID: 781965211
     * Description: SDK product purchase requested
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param productSku Product SKU
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkProductPurchaseRequested(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            productSku: string, // Product SKU 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkProductPurchaseRequested(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,productSku,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_product_purchase_completed
     * Event ID: 781965212
     * Description: SDK product purchase completed
     */
    public BuildSdkProductPurchaseCompleted(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,productSku: string,currency: string,transactionId: string,timeFromSessionStart: number,currencyAmount: number,usdAmount: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965212,S1: sessionId,S2: game,S3: adapter,S4: productSku,S5: currency,S6: transactionId,F1: timeFromSessionStart,F2: currencyAmount,F3: usdAmount};
    }

    /**
     * Event Name: sdk_product_purchase_completed
     * Event ID: 781965212
     * Description: SDK product purchase completed
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param productSku Product SKU
     * @param currency Currency code
     * @param transactionId Transaction id
     * @param timeFromSessionStart Time from session start in seconds
     * @param currencyAmount Amount in currency
     * @param usdAmount Amount in USD
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkProductPurchaseCompleted(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            productSku: string, // Product SKU 
            currency: string, // Currency code 
            transactionId: string, // Transaction id 
            timeFromSessionStart: number, // Time from session start in seconds 
            currencyAmount: number, // Amount in currency 
            usdAmount: number, // Amount in USD 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkProductPurchaseCompleted(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,productSku,currency,transactionId,timeFromSessionStart,currencyAmount,usdAmount);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_product_purchase_error
     * Event ID: 781965213
     * Description: SDK product purchase error
     */
    public BuildSdkProductPurchaseError(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,productSku: string,error: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965213,S1: sessionId,S2: game,S3: adapter,S4: productSku,S5: error,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_product_purchase_error
     * Event ID: 781965213
     * Description: SDK product purchase error
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param productSku Product SKU
     * @param error Error message
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkProductPurchaseError(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            productSku: string, // Product SKU 
            error: string, // Error message 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkProductPurchaseError(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,productSku,error,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
    /**
     * Event Name: sdk_game_started
     * Event ID: 781965214
     * Description: SDK game started
     */
    public BuildSdkGameStarted(
        analyticsEvent: IBaseAnalyticsEvent,sessionId: string,game: string,adapter: string,timeFromSessionStart: number): IAnalyticsEvent {
        return {
            ...analyticsEvent,
            EventId: 781965214,S1: sessionId,S2: game,S3: adapter,F1: timeFromSessionStart};
    }

    /**
     * Event Name: sdk_game_started
     * Event ID: 781965214
     * Description: SDK game started
     * @param sessionId Session id
     * @param game Game name
     * @param adapter Adapter type
     * @param timeFromSessionStart Time from session start in seconds
     * @param createdAt Optional client-side timestamp (epoch milliseconds).
     */
    public SendSdkGameStarted(sessionId: string, // Session id 
            game: string, // Game name 
            adapter: string, // Adapter type 
            timeFromSessionStart: number, // Time from session start in seconds 
            
        createdAt?: number
    ): Promise<void> {
        const eventAnalyticsEvent: IAnalyticsEvent = this.BuildSdkGameStarted(
            this._sender.BuildEvent(createdAt),sessionId,game,adapter,timeFromSessionStart);
        return this._sender.SendEvent(eventAnalyticsEvent);
    }
    
}
